<template>
    <setting-layout :title="$t('pages.user.setting.creator.moderator.title')">
        <v-container>
            <template v-if="data.status == 'accepted'" >
                <h2>{{ $t("pages.user.setting.creator.moderator.youre_moderator") }}</h2>
                    <v-list two-line>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="white--text font-weight-bold">
                                   {{ $t("pages.user.setting.creator.moderator.total_earned") }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action>
                                <span class="white--text font-weight-bold">
                                    ${{ Number(totalEarned || 0).toFixed(2) }}
                                </span>
                            </v-list-item-action>
                        </v-list-item>
                        <v-list-item v-if="!reportStories.length">
                            <v-list-item-content>
                                <v-list-item-title class="grey--text">
                                    {{ $t("pages.user.setting.creator.moderator.no_reports") }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-else
                            v-for="(story, index) in reportStories"
                            :key="index"
                            class="story-card">
                            <v-list-item-content v-if="story.type == 'story'">
                                <v-list-item-title class="white--text text-wrap" v-if="story.blocked">
                                    The {{story.type}} by <strong>{{ story.story_user }}</strong> you reported has been blocked.
                                    <span>You’ve earned <strong>$0.10</strong> as a reward</span>
                                </v-list-item-title>

                                <v-list-item-title class="white--text text-wrap" v-else>
                                    You have submitted a report for a {{story.type}} posted by <strong>{{ story.story_user || 'Unknown User' }}</strong>.
                                </v-list-item-title>

                                <v-list-item-subtitle
                                    class="grey--text text-wrap"
                                    v-if="!story.blocked"
                                >
                                    {{ story.accusation }}
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-content v-if="story.type == 'stream'">
                                <v-list-item-title class="white--text text-wrap" v-if="story.streams_restricted">
                                    The {{story.type}} by <strong>{{ story.stream_user }}</strong> you reported has been restricted.
                                    <span>You’ve earned <strong>$0.10</strong> as a reward</span>
                                </v-list-item-title>

                                <v-list-item-title class="white--text text-wrap" v-else>
                                    You have submitted a report for a {{story.type}} posted by <strong>{{ story.stream_user || 'Unknown User' }}</strong>.
                                </v-list-item-title>

                                <v-list-item-subtitle
                                    class="grey--text text-wrap"
                                    v-if="!story.streams_restricted_at"
                                >
                                    {{ story.accusation }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        
                            <v-list-item-action v-if="story.blocked || story.streams_restricted">
                                <v-chip color="orange" text-color="white" small>
                                    <v-icon left small>mdi-shield-check</v-icon> {{ $t("pages.user.setting.creator.moderator.reward") }}
                                </v-chip>
                            </v-list-item-action>
                            <v-list-item-action v-else>
                                <v-chip color="red" text-color="white" small>
                                    <v-icon left small>mdi-cancel</v-icon> {{ $t("pages.user.setting.creator.moderator.rejected") }}
                                </v-chip>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
            </template>
            <template v-else>
                <div class="mb-4">
                    <p>{{ $t("pages.user.setting.creator.moderator.description_title") }} <br> {{ $t("pages.user.setting.creator.moderator.description_title_detail") }} </p>
                    <p v-html="$t('pages.user.setting.creator.moderator.description_details')"></p>
                    <p>{{ $t("pages.user.setting.creator.moderator.description_bottom") }}</p>
                </div>
                <v-row justify="center" class="mt-8">
                    <gradient-button block @click="save" :loading="$store.state.buttonsLoading.ModeratorBtn" v-if="data.status != 'accepted'" :disabled="data.status === 'requested'">
                            {{ activeStopbutton }} 
                    </gradient-button>
                    <gradient-button :loading="$store.state.buttonsLoading.ModeratorBtn" v-else>
                        You’re a Moderator
                    </gradient-button>
                </v-row>
            </template>
        </v-container>
    </setting-layout>
</template>

<script>
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import GradientButton from "@/components/app/button/GradientButton.vue";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "Moderator",
    data: () => ({
        data: {},
        reportStories: [],
        totalEarned: '0.00'
    }),
    components: { SettingLayout, GradientButton },
    computed: {
        activeStopbutton() {
            return this.data?.status == 'requested' ? this.$t('pages.user.setting.creator.moderator.pending') : this.$t('pages.user.setting.creator.moderator.apply');
        },
    },
    methods: {
        ...mapMutations(["showSnackBar"]),
        ...mapActions([
            'saveModerator',
            'getModerator',
            'getReportStoriesList'
        ]),

        async save() {
            const newStatus = this.data.status === 'rejected' ? 'requested' : (this.data.status === 'pending' ? 'requested' : 'pending');
            await this.saveModerator({
                model: {
                    moderator_request: newStatus,
                }
            }).then((res) => {
                this.errors = {}
                this.data = res.data;
                console.log(this.data.status);
                this.showSnackBar(this.$t('pages.user.setting.creator.moderator.saved'))
            }).catch(err => {
                this.errors = err.response.data.errors;
            });
        },
        async getReportStories() {
            const res = await this.getReportStoriesList();
            this.reportStories = res.data.reportStoriesStreamData || [];
            this.totalEarned = res.data.totalEarned || '';
        }
    }, mounted() {
        this.getModerator()
            .then((res) => {
                this.data = res.data || {};
                console.log(this.data)
                this.name = res.data?.name;
                this.price = res.data?.price;

                if(this.data.status == 'accepted') {
                    this.getReportStories();
                }
            })
    },

}
</script>
<style scoped>
    .story-card {
    border-radius: 12px;
    background-color: #1e1e1e;
    margin-bottom: 8px;
    padding: 4px 10px;
    }
</style>